import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";
import { BoardConfigType } from "./board-types";

export type AssignmentBoardConfigResponse = {
	id?: number;
	created?: string;
	config?: BoardConfigType;
	assignment: number;
	user: number;
};

export type AssignmentBoardConfigRequest = {
	config: BoardConfigType;
	assignment: number;
	user: number;
};

//Will automatically return latest config for each assignment
export const getAssignmentBoardConfigs = (
	assignmentId?: number
): Promise<DRFListResponseWrapper<AssignmentBoardConfigResponse[]>> => {
	let url = `/api/v2/assignment_board_config/`;
	if (assignmentId) url += `?assignment=${assignmentId}`;

	return fetch(url, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => {
		if (res.status !== 200) {
			throw new Error(res.statusText);
		}
		return res.json();
	});
};

//Used to update board config - appends to db (hence we should not delete any configs)
export const createAssignmentBoardConfig = async (
	data: AssignmentBoardConfigRequest
): Promise<AssignmentBoardConfigResponse> => {
	return fetch(`/api/v2/assignment_board_config/`, {
		method: "POST",
		body: JSON.stringify(data),
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
	}).then((res) => {
		if (res.status !== 201) {
			throw new Error(res.statusText);
		}
		return res.json();
	});
};
